import { Heading } from './heading';

export type Headings = Readonly<{ [key: number]: Heading }>;

export const initialHeadings = {};
